export default "__VITE_ASSET__BZZZhzcE__"